import React from 'react';
import PropTypes from 'prop-types';

// Tabler icons (@tabler/icons 2.47.0, the version the Instagram frames load)
// inlined, since the app doesn't carry the Tabler webfont. Stroke icons take
// currentColor; the filled play mark fills with it.
function Svg({ className, children, filled }) {
  return (
    <svg
      className={className}
      viewBox='0 0 24 24'
      width='1em'
      height='1em'
      fill={filled ? 'currentColor' : 'none'}
      stroke={filled ? 'none' : 'currentColor'}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      aria-hidden='true'
      focusable='false'
    >
      {children}
    </svg>
  );
}

Svg.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  filled: PropTypes.bool,
};

const iconProps = { className: PropTypes.string };

export function BrandInstagramIcon({ className }) {
  return (
    <Svg className={className}>
      <path d='M4 4m0 4a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z' />
      <path d='M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0' />
      <path d='M16.5 7.5l0 .01' />
    </Svg>
  );
}
BrandInstagramIcon.propTypes = iconProps;

export function PlayFilledIcon({ className }) {
  return (
    <Svg className={className} filled>
      <path d='M6 4v16a1 1 0 0 0 1.524 .852l13 -8a1 1 0 0 0 0 -1.704l-13 -8a1 1 0 0 0 -1.524 .852z' />
    </Svg>
  );
}
PlayFilledIcon.propTypes = iconProps;

export function StackIcon({ className }) {
  return (
    <Svg className={className}>
      <path d='M12 4l-8 4l8 4l8 -4l-8 -4' />
      <path d='M4 12l8 4l8 -4' />
      <path d='M4 16l8 4l8 -4' />
    </Svg>
  );
}
StackIcon.propTypes = iconProps;

export function EyeOffIcon({ className }) {
  return (
    <Svg className={className}>
      <path d='M10.585 10.587a2 2 0 0 0 2.829 2.828' />
      <path d='M16.681 16.673a8.717 8.717 0 0 1 -4.681 1.327c-3.6 0 -6.6 -2 -9 -6c1.272 -2.12 2.712 -3.678 4.32 -4.674m2.86 -1.146a9.055 9.055 0 0 1 1.82 -.18c3.6 0 6.6 2 9 6c-.666 1.11 -1.379 2.067 -2.138 2.87' />
      <path d='M3 3l18 18' />
    </Svg>
  );
}
EyeOffIcon.propTypes = iconProps;

export function EyeIcon({ className }) {
  return (
    <Svg className={className}>
      <path d='M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0' />
      <path d='M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6' />
    </Svg>
  );
}
EyeIcon.propTypes = iconProps;

export function LoaderIcon({ className }) {
  return (
    <Svg className={className}>
      <path d='M12 3a9 9 0 1 0 9 9' />
    </Svg>
  );
}
LoaderIcon.propTypes = iconProps;

export function AlertTriangleIcon({ className }) {
  return (
    <Svg className={className}>
      <path d='M12 9v4' />
      <path d='M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z' />
      <path d='M12 16h.01' />
    </Svg>
  );
}
AlertTriangleIcon.propTypes = iconProps;

export function InfoCircleIcon({ className }) {
  return (
    <Svg className={className}>
      <path d='M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0' />
      <path d='M12 9h.01' />
      <path d='M11 12h1v4h1' />
    </Svg>
  );
}
InfoCircleIcon.propTypes = iconProps;

export function XIcon({ className }) {
  return (
    <Svg className={className}>
      <path d='M18 6l-12 12' />
      <path d='M6 6l12 12' />
    </Svg>
  );
}
XIcon.propTypes = iconProps;

export function CheckIcon({ className }) {
  return (
    <Svg className={className}>
      <path d='M5 12l5 5l10 -10' />
    </Svg>
  );
}
CheckIcon.propTypes = iconProps;
